const PAGE_IDS = {
    BADGES: 'badges-page',
    IN_PROGRESS: 'badges-in-progress-page',
} as const;

export default PAGE_IDS;
